import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as helpers from './helpers.js'
import * as globals from './globals.js'


const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
  },
}));


function CreateUser(props) {
  const classes = useStyles()
  const serverStatus = useSelector(state => state.serverStatus)
  const authenticated = useSelector(state => state.authenticated)
  const [loaded, setLoaded] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [formPosted, setFormPosted] = useState(false);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [validity, setValidity] = useState({createUser_Name: true,
                                            createUser_Password: true,
                                            createUser_Password2: true,
                                            createUser_Email: true})


  let form = {createUser_Name: null,
              createUser_Password: null,
              createUser_Password2: null,
              createUser_Email: null,
              createUser_Role: null, 
              createUser_Role_default: 1}

  const [roleValue, setRoleValue] = useState(form.createUser_Role_default)

  useEffect(() => {
     
     if (! loaded && authenticated) {
       console.log('DEBUG','GET ROLES')
       helpers.getAPI(
         { func: (resp) => {
                 setUserRoles(resp)
                 setLoaded(true)
            }, 
           uri: globals.myAPIurl+'/getdb?tab=users'
         })
     }


  }, [authenticated]);


  useEffect(() => {     
     if (formPosted) {
        resetForm()
     }
   }, [formPosted]);


  
  var resetForm = () => {
    let key
    for (key of Object.keys(form)) {
       if (key.substring(key.lastIndexOf("_")) !== "_default") {
         form[key].value = form[key+'_default'] ? form[key+'_default'] : null
       }
    }
    setRoleValue(form.createUser_Role_default)

  }

  var handleSubmit = (e) => {
    
    let validateObject = {createUser_Name: helpers.validate("required", form.createUser_Name.value),
                 createUser_Password: helpers.validate("password", form.createUser_Password.value),
                 createUser_Password2: helpers.validate("password", form.createUser_Password2.value),
                 createUser_Email: helpers.validate("email", form.createUser_Email.value)}

    setValidity(validateObject)

    if (form.createUser_Password.value != form.createUser_Password2.value) {
       helpers.alertMessage('Passwords must match!', globals.ERRO, true, 10000)
       return
    }

    if (! helpers.validate("all_valid", validateObject)) {
       helpers.alertMessage('Please enter all required fields!', globals.ERRO, true, 10000)
       return
    }


    let Data = helpers.mapFormToData(form)

    console.log('DEBUG', 'SEND TO SERVER', Data )
  
    setFormPosted(false)
    setApiCallInProgress(true)
    helpers.postAPI(
         { func: function(resp) {
              setApiCallInProgress(false)
              //After receiving response from server
              if (resp.status === 'OK') {
                  helpers.closeMessage()
                  helpers.alertMessage('User created.', globals.INFO, true, 5000)           
                  setFormPosted(true)
              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+resp.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/createuser',
           data: Data
         })

  }


  if (! authenticated) return (<div className="section has-background-light">
                          NOT AUTHENTICATED
                        </div>)


  if (! loaded) return (<div className="section has-background-light">
                          <CircularProgress />
                        </div>)


  let print_roles = userRoles.map((role)=>{
    return <MenuItem value={role.id}>{role.name}</MenuItem>
  })

  return (
  	<div className="section has-background-light">
  	  
  	  <div class="field">   
       <div class="control"> 
         <TextField
          inputRef = {(c)=>form.createUser_Name = c}
          error = {! validity.createUser_Name}
          helperText = {(validity.createUser_Name) ? null : "Name is required"}
          required
          id="create-user-username"
          label="Name"
          variant="outlined"
        />
      </div>
     </div>

     <div class="field">
      <div class="control"> 
        <TextField
          inputRef = {(c)=>form.createUser_Password = c}
          error = {! validity.createUser_Password}
          helperText = {(validity.createUser_Password) ? null : "Password minimum length must be 5."}
          required
          id="create-user-password"
          label="Password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
        />
      </div>
     </div>

     <div class="field">
      <div class="control"> 
        <TextField
          inputRef = {(c)=>form.createUser_Password2 = c}
          error = {! validity.createUser_Password2}
          helperText = {(validity.createUser_Password2) ? null : "Password minimum length must be 5."}
          required
          id="create-user-password-2"
          label="Repeat password"
          type="password"
          autoComplete="current-password"
          variant="outlined"
        />
      </div>
     </div>


     <div class="field">
      <div class="control"> 
        <TextField
          inputRef = {(c)=>form.createUser_Email = c}
          error = {! validity.createUser_Email}
          helperText = {(validity.createUser_Email) ? null : "Email is required"}
          required
          id="create-user-email"
          label="Email"
          type="email"
          variant="outlined"
        />
      </div>
     </div>


     <div class="field">
      <div class="control"> 

      <FormControl variant="outlined" className={classes.root}>
        <InputLabel id="user-create-role-label">Role</InputLabel>
        <Select
          inputRef = {(c)=>form.createUser_Role = c}
          labelId="user-create-role-label"
          id="demo-simple-select-outlined"
          value={roleValue}
          onChange={(e)=>setRoleValue(e.target.value)}
          defaultValue={form.createUser_Role_default}
          label="Role"
        >
          {print_roles}

        </Select>
      </FormControl>


      </div>
     </div>
     

     <div class="columns is-mobile is-centered">
      <div class="column is-half">
        <Button disabled={apiCallInProgress || !serverStatus} color="primary" onClick={handleSubmit}>Create</Button> 
      </div>
    </div>
     

    </div>
  )

}

export default CreateUser